import React from 'react'

import * as S from './styles'

/**
 * @typedef {'xs' | 'sm' | 'md' | 'lg' | 'xl'} Spacing
 */

/**
 * @typedef {Object} SimpleGridProps
 * @property {number} [cols]
 * @property {Spacing} [spacing]
 * @property {React.ReactNode} [children]
 */

/**
 * @param {SimpleGridProps} props
 */
export default function SimpleGrid({ cols = 1, spacing = 'xs', children }) {
  return (
    <S.SimpleGrid cols={cols} spacing={spacing}>
      {children}
    </S.SimpleGrid>
  )
}
